import { refreshToken } from './refreshToken'

export const apiGetNoneAuth = async (url: string) => {
  try {
    const res = await fetch(url, {
      method: 'GET',
      headers: {
        'X-Raund-Token': `${process.env.NEXT_PUBLIC_RAUND_TOKEN}`,
      },
    })

    console.log(res)
    const result = await res.json()
    console.log(result)

    return result
  } catch (error) {
    console.log({ error })
  }
}

export const apiGet = async (url: string) => {
  try {
    const res = await fetch(url, {
      method: 'GET',
      headers: {
        'X-Authorization': localStorage.getItem(
          `${process.env.NEXT_PUBLIC_SERVICE_NAME}-jwt`
        ),
        'X-Raund-Token': `${process.env.NEXT_PUBLIC_RAUND_TOKEN}`,
      },
    })

    console.log(res)
    const result = await res.json()
    console.log(result)

    if (result.status === 403) {
      refreshToken()
      return
    }

    if (result.status === 500) {
      console.error(result)
      return
    }

    return result
  } catch (error) {
    // alert(error)
    console.log({ error })
  }
}

export const apiPost = async (url: string, body?: any) => {
  try {
    const res = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Authorization': localStorage.getItem(
          `${process.env.NEXT_PUBLIC_SERVICE_NAME}-jwt`
        ),
        'X-Raund-Token': `${process.env.NEXT_PUBLIC_RAUND_TOKEN}`,
      },
      body: JSON.stringify(body),
    })

    console.log(res)
    const result = await res.json()
    console.log(result)

    if (result.status === 403) {
      refreshToken()
      return
    }

    if (result.status === 500) {
      console.error(result)
      return
    }

    return result
  } catch (error) {
    console.log({ error })
  }
}

export const apiPostNoneBody = async (url: string) => {
  try {
    const res = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Authorization': localStorage.getItem(
          `${process.env.NEXT_PUBLIC_SERVICE_NAME}-jwt`
        ),
        'X-Raund-Token': `${process.env.NEXT_PUBLIC_RAUND_TOKEN}`,
      },
    })

    const result = await res.json()
    console.log(result)

    if (result.status === 403) {
      refreshToken()
      return
    }

    if (result.status === 500) {
      console.error(result)
      return
    }

    return result
  } catch (error) {
    console.log(error)
  }
}

export const apiDelete = async (url: string) => {
  try {
    const res = await fetch(`${url}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'X-Authorization': localStorage.getItem(
          `${process.env.NEXT_PUBLIC_SERVICE_NAME}-jwt`
        ),
        'X-Raund-Token': `${process.env.NEXT_PUBLIC_RAUND_TOKEN}`,
      },
    })

    const result = await res.json()
    console.log(result)

    if (result.status === 403) {
      refreshToken()
      return
    }

    if (result.status === 500) {
      console.error(result)
      return
    }

    return result
  } catch (error) {
    console.log(error)
  }
}
